var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.url)?_c('div',[_c('img',{staticClass:"vp-custom-logo",attrs:{"src":_vm.url,"width":"100%","height":"auto"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }